import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Parameter } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ParameterService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getParameter(
    id,
    schema = {
      id: null,
      name: null,
    }
  ): Promise<Parameter> {
    return new Parameter(await this.core.services.parameter.getById(id, schema))
  }

  async getParameters(
    parameters: any = {},
    schema: any = { id: null, name: null }
  ): Promise<{
    items: Parameter[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.parameter.getList(parameters, schema)
  }

  createParameter(parameter: Partial<Parameter>, schema: Partial<Parameter>): Promise<Parameter> {
    return this.core.services.parameter.create(parameter, schema)
  }

  updateParameter(parameter: Partial<Parameter>, schema: Partial<Parameter>): Promise<Parameter> {
    return this.core.services.parameter.update(parameter, schema)
  }

  deleteParameter(parameter: Partial<Parameter>): Promise<Parameter> {
    return this.core.services.parameter.delete(parameter)
  }
}
